
import { AssessmentAiListing } from "@/store/modules/recruiter/interfaces";
import Vue from "vue";

export default Vue.extend({
  name: "RecentAssessmentsTable",
  props: {
    assessments: {
      type: Array as () => AssessmentAiListing[],
      default: () => []
    }
  },
  methods: {
    getStatusColor(status: string): string {
      switch (status) {
        case "active":
          return "primary";
        case "draft":
          return "success";
        case "archived":
          return "error";
        default:
          return "primary";
      }
    }
  }
});
